import { useEffect, useState } from "react";

import QWPartnerForm from "components/Insurance/QuickWidgetPartner/QWPartnerForm";
import QWPartnerValuationSection from "components/Insurance/QuickWidgetPartner/QWPartnerValuationSection";
import { listedQuickWidgetRefs } from "constants/refs";
import { MSMProfile, QuickWidgetResult } from "model/object/quick-widget-result";
import { SourceQuery } from "model/object/ref-query";
import { useRouter } from "next/router";

export default function QuickWidgetGrey() {
	const [reg, setReg] = useState("");
	const [step, setStep] = useState(1);
	const [results, setResults] = useState<QuickWidgetResult>({} as QuickWidgetResult);
	const [profile, setProfile] = useState<MSMProfile>({} as MSMProfile);
	const router = useRouter();
	const { source } = router.query as SourceQuery;
	const [sourceData, setSourceData] = useState("carcloud");

	useEffect(() => {
		if (listedQuickWidgetRefs.includes(source)) {
			setSourceData(source);
		}
	}, [source]);

	return (
		<div className="my-garage-page flex flex-grow flex-col">
			<div className="flex-grow bg-[#27374A] px-2 py-3 text-xl font-bold text-white tablet:!px-2 ">
				<div className="mb-2 flex flex-col text-center ">
					{step === 1 && <h2 className="text-xl font-extrabold">Car Insurance Quick Quote</h2>}
					{step === 2 && (
						<div className="align-items-center mx-auto flex flex-col text-white">
							<p className="mb-2 text-[20px] font-bold">Your Insurance Guide Price </p>
							<p className="px-2 text-[14px] font-light leading-5 text-white">
								Based on our data, drivers like you could get insurance quotes in the following range
							</p>
						</div>
					)}
				</div>
				{step === 1 && <QWPartnerForm source={sourceData} reg={reg} setStep={setStep} setResults={setResults} setProfile={setProfile} setReg={setReg} />}
				{step == 2 && <QWPartnerValuationSection source={sourceData} type={"grey"} result={results} profile={profile} reg={reg} />}
			</div>
		</div>
	);
}
